import includes from 'lodash/includes';

import { createSelector } from '@lumapps/redux/reselect';
import type { BackOfficeStore, BaseStore } from '@lumapps/redux/types';

export const featuresSelector = (state: BackOfficeStore): Record<string, any> =>
    state.feature ? state.feature.entities : state.features;

export const customerSelector = (state: BaseStore) => state?.customer || {};

export const enabledFeaturesSelector = createSelector(customerSelector, (customer) => customer?.enabledFeatures);
export const disabledFeaturesSelector = createSelector(customerSelector, (customer) => customer?.excludedFeatures);
export const enabledBeekeeperFeaturesSelector = createSelector(
    customerSelector,
    (customer) => customer?.beekeeperEnabledFeatures ?? [],
);

export const isFeatureEnabled = (token: string) =>
    createSelector(enabledFeaturesSelector, (enabledFeatures) => {
        return includes(enabledFeatures, token);
    });

export const isBeekeeperFeatureEnabled = (token: string) =>
    createSelector(enabledBeekeeperFeaturesSelector, (enabledFeatures) => {
        return includes(enabledFeatures, token);
    });
